import { downloadFile, requestJson, requestMultipart } from "@/lib/api";

export interface ImportLine {
  id: string;
  lineNumber: number;
  targetRef: string | null;
  targetName: string | null;
  unitLabel: string | null;
  currentCost: number | null;
  newCost: number | null;
  referenceDate: string | null;
  variationPercent: number | null;
  status: "VALID" | "WARN_DATA_ANTIGA" | "IGNORED" | "ERRO";
  reasonCode: string | null;
  message: string | null;
  requiresAck: boolean;
  applyResult: string | null;
  appliedVersion: number | null;
}

export interface ImportSummary {
  total: number;
  valid: number;
  warning: number;
  ignored: number;
  error: number;
}

export interface ImportPreview {
  batchId: string | null;
  domain: string;
  status: string;
  expiresAt: string | null;
  summary: ImportSummary;
  fileErrors: string[];
  lines: ImportLine[];
}

export interface ImportResult {
  batchId: string;
  status: string;
  appliedCount: number;
  appliedAt: string | null;
  lines: ImportLine[];
}

/** Base path por domínio: /api/v1/admin/product-costs/import ou /api/v1/admin/packaging-materials/import. */
export async function downloadImportTemplate(basePath: string, filename: string): Promise<void> {
  await downloadFile(`${basePath}/template.xlsx`, filename);
}

export async function previewImport(basePath: string, file: File): Promise<ImportPreview> {
  const form = new FormData();
  form.append("file", file);
  return requestMultipart<ImportPreview>(`${basePath}/preview`, form);
}

export async function confirmImport(
  basePath: string,
  batchId: string,
  payload: { selectedLineIds: string[]; acknowledgedOldDateLineIds: string[]; idempotencyKey: string },
): Promise<ImportResult> {
  return requestJson<ImportResult>(`${basePath}/${batchId}/confirm`, { method: "POST", body: payload });
}

/** Auditoria: consulta o resultado/estado de uma importação pelo batchId (restrito ao criador). */
export async function fetchImportResult(basePath: string, batchId: string): Promise<ImportResult> {
  return requestJson<ImportResult>(`${basePath}/${batchId}`, { method: "GET" });
}
